
import React, { useState, useEffect, useCallback } from "react";
import Container from "../../components/common/Container";
import "./TicketList.css";
import TicketChatPopup from "./TicketChatPopup";
import CreateTickitPopup from "../../components/menudropdoenpopup/CreateTickitPopup";

export default function TickitList() {
    document.title = "Support Tickets";

    const token = sessionStorage.getItem("token");

    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [refreshing, setRefreshing] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [isCreateTickit, setisCreateTickit] = useState(false);
    const [sendingReply, setSendingReply] = useState(false);

    const fetchTickets = useCallback(async (isRefresh = false) => {
        if (!token) {
            setError("Authentication token not found.");
            setLoading(false);
            setRefreshing(false);
            return;
        }

        if (isRefresh) {
            setRefreshing(true);
        } else {
            setLoading(true);
        }

        setError("");

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/support/tickets`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch tickets (${response.status})`
                );
            }

            const data = await response.json();

            if (!Array.isArray(data)) {
                throw new Error("Invalid ticket response from server.");
            }

            setTickets(data);
        } catch (err) {
            setError(err.message || "Unable to load tickets.");
        } finally {
            setLoading(false);
            setRefreshing(false);
        }
    }, [token]);

    useEffect(() => {
        fetchTickets();
    }, [fetchTickets]);

    const formatDatefromAPI = (date) => {
        if (!date) return "-";

        const parsedDate = new Date(date);

        if (Number.isNaN(parsedDate.getTime())) {
            return "-";
        }

        return parsedDate.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "WAITING_FOR_SUPPORT":
                return "ticket-status waiting";
            case "RESOLVED":
                return "ticket-status resolved";
            case "CLOSED":
                return "ticket-status closed";
            default:
                return "ticket-status";
        }
    };

    const handleClose = () => {
        setisCreateTickit(false);
        fetchTickets(true);
    }

    return (
        <>
            <Container size="full">
                <div className="account-sec">
                    <div className="acount-header-filter">
                        <div className="title-wraper">
                            <span className="v-border"></span>
                            <h3 className="title">Support Tickets</h3>
                        </div>
                    </div>

                    <div className="account-table">
                        <div className="ticket-toolbar" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                            alignItems: "center",
                        }}>
                            <span>
                                Total Tickets: <strong>{tickets.length}</strong>
                            </span>

                            <button
                                type="button"
                                className="btn"
                                onClick={() => setisCreateTickit(true)}
                            >
                                Create Support Ticket
                            </button>
                        </div>

                        {loading ? (
                            <div className="loader-page">
                                <span className="loader"></span>
                            </div>
                        ) : error ? (
                            <div className="ticket-error">
                                <span>{error}</span>
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={() => fetchTickets()}
                                >
                                    Retry
                                </button>
                            </div>
                        ) : tickets.length === 0 ? (
                            <div className="ticket-empty">
                                No tickets found.
                            </div>
                        ) : (
                            <table
                                border="1"
                                cellPadding="10"
                                cellSpacing="0"
                                className="user-data-table"
                            >
                                <thead>
                                    <tr>
                                        <th>Ticket No.</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {tickets.map((ticket) => (
                                        <tr key={ticket._id}
                                            onClick={() => setSelectedTicket(ticket)}
                                            style={{ cursor: "pointer" }}>
                                            <td>
                                                <strong>
                                                    #{ticket.ticketNo || "-"}
                                                </strong>
                                            </td>

                                            <td>
                                                <span
                                                    className={getStatusClass(
                                                        ticket.status
                                                    )}
                                                >
                                                    {ticket.status
                                                        ? ticket.status.replace(
                                                            /_/g,
                                                            " "
                                                        )
                                                        : "-"}
                                                </span>
                                            </td>

                                            <td>
                                                {formatDatefromAPI(
                                                    ticket.createdAt
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </Container>
            <TicketChatPopup
                ticket={selectedTicket}
                onClose={() => {
                    setSelectedTicket(null);
                    fetchTickets(true);
                }}
            />
            <CreateTickitPopup isopen={isCreateTickit} handleClose={handleClose} />
        </>
    );
}
